var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "24px",
    viewBox: "0 0 41 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Crown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscritpion-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-/-#",
    transform: "translate(-726.000000, -268.000000)",
    fill: "#FFC43D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(520.000000, 268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Crown",
    transform: "translate(206.502219, 0.406213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1666667,19.3817531 C19.6666667,19.8817531 20.5,19.8817531 20.8333333,19.3817531 L28.6666667,11.5484197 L20.8333333,3.88175306 C20.3333333,3.38175306 19.5,3.38175306 19,3.88175306 L11.1666667,11.5484197 L19.1666667,19.3817531 Z",
    id: "Path",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,0.164823835 L20.8333333,17.4310238 C20.3333333,17.9062404 19.5,17.9062404 19.1666667,17.4310238 L1,0.164823835 C0.666666667,-0.151987174 -2.96059473e-15,0.164823835 -2.96059473e-15,0.640040349 L-2.96059473e-15,20.7575394 C-2.96059473e-15,21.7079725 0.833333333,22.5 1.83333333,22.5 L38.1666667,22.5 C39.1666667,22.5 40,21.7079725 40,20.7575394 L40,0.481634845 C40,0.00641833046 39.3333333,-0.151987174 39,0.164823835 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.f0bec623a79f2e601981b6696073bd39.svg";
export { ForwardRef as ReactComponent };